import {
    CONTENTS_TYPE,
    DEFAULT_POSITION,
    UPLOAD_STATUS,
    S3_BUCKET_KEY,
} from '../const/general'
import errorHandler from './upload_error';
import generateMovieThumbnail from './generate_movie_thumbnail';
import saveContentsInfo from './save_contents_info';
import multipartUploadProc from './multipart_upload';
import cliAuth from './axios_cli';



export const chunkUpload = async (
    movie,
    item,
    setCounter,
    setSuccessContents,
    successContents,
    setErrorContents,
    errorContents
) => {

    // アップロード
    const upload = async (original_s3_prefix, thumbnail_s3_prefix) => {
        try {
            // 分割アップロード
            const uploadPromise =
                multipartUploadProc(movie, original_s3_prefix, setCounter)
            // サムネイルアップロード
            const thumbnailPromise =
                thumbnailUploadProc(thumbnail_s3_prefix);
            // ルートログアップロード
            const routeLogPromise =
                item.route_log ? routeLogUploadProc() : Promise.resolve(true);

            const results = await Promise.allSettled([
                uploadPromise,
                thumbnailPromise,
                routeLogPromise
            ]);

            const multiUpload = results[0].status === "fulfilled" && results[0].value;
            const thumbnailUpload = results[1].status === "fulfilled" && results[1].value;
            const routeLogUpload = results[2].status === "fulfilled" && results[2].value;

            // 動画の付帯情報をDBに登録
            if (multiUpload && thumbnailUpload && routeLogUpload) {
                await saveContentsInfo(movie, item, setSuccessContents, errorContents, setErrorContents)
            }
        } catch (e) {
            console.log(e);
            // 分割アップロード処理で失敗した場合の処理
            errorHandler(UPLOAD_STATUS.CHUNCK_PUT, movie, item, errorContents, setErrorContents)
        }
    }

    // サムネイルアップロード
    const thumbnailUploadProc = async (thumbnail_s3_prefix) => {
        try {
            // 画像群の場合はサムネイル作成はLambdaに任せる
            // サムネイル生成
            if (movie.contentType === CONTENTS_TYPE.MOVIE) {
                const thumbnail = await generateMovieThumbnail(movie.uploadFile);
                // サムネイルアップロード
                const res = await cliAuth.post("upload/put-url/", {
                    key: thumbnail_s3_prefix + movie.id + ".png",
                    contentType: "image/png",
                });

                const uploadRes = await fetch(res.data.url, {
                    method: "PUT",
                    headers: { "Content-Type": "image/png" },
                    body: thumbnail,
                });

                if (!uploadRes.ok) {
                    throw new Error("thumbnail upload failed");
                }
            }
            console.log('movie.thumbnailUrl', movie.thumbnailUrl)
            if (movie.contentType === CONTENTS_TYPE.LAS && movie.thumbnailUrl) {
                // サムネイルアップロード
                // Lasのサムネイルはmovie.thumbnailUrlに直接ファイルオブジェクトが入っている
                // サムネイルBlob → PNGに変換(pngに固定するのが表示側で都合がいいから)
                const imageBitmap = await createImageBitmap(movie.thumbnailUrl);
                const canvas = document.createElement('canvas');
                canvas.width = imageBitmap.width;
                canvas.height = imageBitmap.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(imageBitmap, 0, 0);

                // PNG Blobとして書き出し
                const pngBlob = await new Promise((resolve, reject) =>
                    canvas.toBlob(blob => {
                        if (!blob) reject(new Error("blob create failed"));
                        else resolve(blob);
                    }, 'image/png')
                );
                const res = await cliAuth.post("upload/put-url/", {
                    key: thumbnail_s3_prefix + movie.id + ".png",
                    contentType: "image/png",
                });

                const uploadRes = await fetch(res.data.url, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "image/png",
                    },
                    body: pngBlob,
                });
                if (!uploadRes.ok) {
                    throw new Error("thumbnail upload failed");
                }
            }
            return true

        } catch (e) {
            console.log(e);
            // 分割アップロード最終処理で失敗した場合の処理
            errorHandler(UPLOAD_STATUS.INFO_SAVE, movie, item, errorContents, setErrorContents)
            return false
        }
    }

    // ルートログアップロード
    const routeLogUploadProc = async () => {
        try {
            const key = S3_BUCKET_KEY.MOVIE_ROUTE_LOG + movie.id
                + '.' + item.route_log_file_name.split('.').pop()

            if (movie.contentType === CONTENTS_TYPE.MOVIE) {
                // ルートログアップロード
                const res = await cliAuth.post("upload/put-url/", {
                    key,
                    contentType: item.route_log.type,
                });

                const uploadRes = await fetch(res.data.url, {
                    method: "PUT",
                    headers: {
                        "Content-Type": item.route_log.type,
                    },
                    body: item.route_log,
                });

                if (!uploadRes.ok) {
                    throw new Error("route log upload failed");
                }
            }

            return true

        } catch (e) {
            console.log(e);
            // 分割アップロード最終処理で失敗した場合の処理
            errorHandler(UPLOAD_STATUS.INFO_SAVE, movie, item, errorContents, setErrorContents)
            return false
        }
    }

    // アップロード成功リストにあるファイルは何もしない
    if (successContents.some(content => content.movieId === movie.id)) {
        return
    }

    // データ補完
    if (item.latitude == undefined) {
        item.latitude = DEFAULT_POSITION.LAT
    }
    if (item.longitude == undefined) {
        item.longitude = DEFAULT_POSITION.LNG
    }
    if (item.emergency_level == undefined) {
        item.emergency_level = 0
    }

    let original_s3_prefix = S3_BUCKET_KEY.MOVIE_ORIGINAL
    let thumbnail_s3_prefix = S3_BUCKET_KEY.MOVIE_THUMBNAIL
    switch (movie.contentType) {
        case CONTENTS_TYPE.MOVIE:
            original_s3_prefix = S3_BUCKET_KEY.MOVIE_ORIGINAL
            thumbnail_s3_prefix = S3_BUCKET_KEY.MOVIE_THUMBNAIL
            break
        case CONTENTS_TYPE.IMAGE:
            original_s3_prefix = S3_BUCKET_KEY.IMAGE_ORIGINAL
            thumbnail_s3_prefix = S3_BUCKET_KEY.IMAGE_THUMBNAIL
            break
        case CONTENTS_TYPE.ZIP:
            original_s3_prefix = S3_BUCKET_KEY.ZIP_ORIGINAL
            thumbnail_s3_prefix = S3_BUCKET_KEY.ZIP_THUMBNAIL
            break
        case CONTENTS_TYPE.LAS:
            original_s3_prefix = S3_BUCKET_KEY.LAS_ORIGINAL
            thumbnail_s3_prefix = S3_BUCKET_KEY.LAS_THUMBNAIL
            break
        default:
            original_s3_prefix = S3_BUCKET_KEY.MOVIE_ORIGINAL
            thumbnail_s3_prefix = S3_BUCKET_KEY.MOVIE_THUMBNAIL
            break
    }

    await upload(original_s3_prefix, thumbnail_s3_prefix)

}
